import React from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import { Facebook, Linkedin, Twitter, Envelope } from "react-bootstrap-icons";
import FloatingOrbs from "../decor/FloatingOrbs";
import "./Footer.css";

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="nz-footer">
      <FloatingOrbs className="nz-footer__orbs" />
      <div className="nz-footer__inner">
        <Container>
          <Row className="nz-footer__row">
            <Col md="5" sm="12" data-aos="nz-rise">
              <h3 className="nz-footer__brand">Noser Technology PH Corp</h3>
              <p className="nz-footer__about">
                We are a team of passionate people whose goal is to improve everyone's life
                through disruptive products. We build great products to solve your business
                problems — designed for small to medium-size companies willing to optimize
                their performance.
              </p>
            </Col>

            {/* <Col md="3" sm="6" data-aos="nz-rise" data-aos-delay="100">
              <h4 className="nz-footer__head">Useful Links</h4>
              <ul className="nz-footer__links">
                <li>
                  <Link to={`${process.env.PUBLIC_URL}/auth-login`} className="nz-footer__link nz-underline">
                    Login
                  </Link>
                </li>
                <li>
                  <Link to={`${process.env.PUBLIC_URL}/auth-register`} className="nz-footer__link nz-underline">
                    Register
                  </Link>
                </li>
              </ul>
            </Col> */}

            <Col md="4" sm="6" data-aos="nz-rise" data-aos-delay="180">
              <h4 className="nz-footer__head">Connect with us</h4>
              <div className="nz-footer__social">
                <a href="#!" aria-label="Website" className="nz-footer__icon">
                  <Envelope />
                </a>
                <a href="#!" aria-label="Facebook" className="nz-footer__icon"><Facebook /></a>
                <a href="#!" aria-label="LinkedIn" className="nz-footer__icon"><Linkedin /></a>
                <a href="#!" aria-label="Twitter" className="nz-footer__icon"><Twitter /></a>
              </div>
            </Col>
          </Row>

          <div className="nz-footer__bar">
            <span>© {year} Noser Technology PH Corp. All rights reserved.</span>
          </div>
        </Container>
      </div>
    </footer>
  );
};

export default Footer;
